import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import FormInput from "../../Common/FormInputs/MuiTextField";
import AppButton from "../../Common/Button/Button";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../../theme/useDesignTokens";
import { selectMenuProps } from "../../../utils/selectMenuProps";

const ChannelAndSwitches = ({
    channelAndSwitchDevices,
    deviceTypes,
    addChannelAndSwitches
}) => {
    const [channelCount, setChannelCount] = useState(0);
    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const inputFieldHeight = 45;
    const focusOutlineSx = {
        "& .MuiOutlinedInput-root": { height: inputFieldHeight, minHeight: inputFieldHeight },
        "& .MuiInputBase-input": { height: `${inputFieldHeight}px !important`, minHeight: `${inputFieldHeight}px !important`, boxSizing: "border-box" },
        "& .MuiOutlinedInput-notchedOutline": { border: "1px solid rgba(0, 0, 0, 0.42) !important" },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0, 0, 0, 0.87)" },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: `${primaryColor} !important`, borderWidth: "1px",
        },
        "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.42) !important", borderWidth: "1px",
        },
        "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-expanded": { color: `${primaryColor} !important` },
    };
    const selectInputSx = {
        height: inputFieldHeight,
        width: "100%",
        "& .MuiOutlinedInput-root": { height: inputFieldHeight },
        "& .MuiSelect-select": { display: "flex", alignItems: "center", padding: "8.5px 14px !important", boxSizing: "border-box" },
        ...focusOutlineSx,
    };

    useEffect(() => {
        if (channelAndSwitchDevices && channelAndSwitchDevices.length > 0) {
            setChannelCount(channelAndSwitchDevices.length);
        }
    }, []);
    function onAddNewDevice() {
        let updatedChannelsAndSwitches = [...channelAndSwitchDevices]
        updatedChannelsAndSwitches.push({
            name: "",
            channel: ('0' + (channelCount)).slice(-2),
            type: ""
        })

        addChannelAndSwitches(updatedChannelsAndSwitches)

        setChannelCount(channelCount + 1)
    }

    function onChangeDeviceName(index, name) {
        let elements = [...channelAndSwitchDevices]
        elements[index].name = name

        addChannelAndSwitches(elements)
    }

    function onChangeDeviceType(index, type) {
        let elements = [...channelAndSwitchDevices]
        elements[index].type = type

        addChannelAndSwitches(elements)
    }

   function onDeleteDevice(indexToDelete) {
    let updatedChannelsAndSwitches = channelAndSwitchDevices.filter((element, index) => {
        return index !== indexToDelete;
    });

    // Recalculate channels to ensure 00, 01, 02, etc.
    updatedChannelsAndSwitches = updatedChannelsAndSwitches.map((element, index) => {
        return {
            ...element,
            channel: ('0' + (index)).slice(-2)
        };
    });

    addChannelAndSwitches(updatedChannelsAndSwitches);
    setChannelCount(updatedChannelsAndSwitches.length);
}
    
    const deviceTypeOptions = (deviceTypes && typeof deviceTypes === "object")
        ? Object.keys(deviceTypes).map((key) => ({ value: key, label: deviceTypes[key] }))
        : [];

    return (
        <Fragment>
            <Box sx={{ mb: 2, width: "100%" }}>
                <Box component="span" sx={{ display: "block", fontWeight: 600, fontSize: "0.875rem", color: "rgba(0, 0, 0, 0.6)", mb: 0.75 }}>
                    Devices and Switches
                </Box>
                <AppButton
                    variant="primary"
                    size="medium"
                    onClick={() => onAddNewDevice()}
                >
                    Add New Device
                </AppButton>
            </Box>
            {channelAndSwitchDevices && channelAndSwitchDevices.map((switchElement, index) => (
                <Grid2 container key={index} spacing={2} sx={{ mb: 3, alignItems: "flex-end" }}>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <FormInput
                            label="Channel"
                            value={channelAndSwitchDevices[index]["channel"]}
                            disabled
                            sx={focusOutlineSx}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <FormInput
                            type="select"
                            label="Select Device Type"
                            value={channelAndSwitchDevices[index]["type"] || ""}
                            onChange={(e) => onChangeDeviceType(index, e.target.value)}
                            options={deviceTypeOptions}
                            sx={selectInputSx}
                            MenuProps={selectMenuProps}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end", width: "100%" }}>
                            <FormInput
                                label="Device Name"
                                placeholder="Enter Device Name"
                                value={channelAndSwitchDevices[index]["name"] || ""}
                                onChange={(e) => onChangeDeviceName(index, e.target.value)}
                                sx={{ ...focusOutlineSx, flex: 1, minWidth: 0 }}
                                InputLabelProps={{ shrink: true }}
                            />
                            <IconButton
                                aria-label="delete"
                                onClick={() => onDeleteDevice(index)}
                                size="small"
                                sx={{ color: "action.active", flexShrink: 0, pb: 0.5 }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid2>
                </Grid2>
            ))}
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    ModelData: state.getModel
});

export default connect(mapStateToProps)(ChannelAndSwitches);